import { render, staticRenderFns } from "./AutomationFlowStraight.vue?vue&type=template&id=d64716ba&"
var script = {}
import style0 from "./AutomationFlowStraight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports